'use strict';

var React = require('react');
var pill = require('./pill.js');
var pillButton_styles = require('./pillButton.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const PillButton = ({ id, onClick, color = 'dark', value, label, withTooltip, tooltipPlacement = 'left', active = false, }) => (React__default.default.createElement(pillButton_styles.PillButtonStyled, { id: id, onClick: onClick, variant: "secondary", size: "m", "$active": active },
    React__default.default.createElement(pill.Pill, { color: color, label: label, withTooltip: withTooltip, tooltipPlacement: tooltipPlacement })));

exports.PillButton = PillButton;
//# sourceMappingURL=pillButton.js.map
